
import http from "../http";

const PagesService = {

    getPagesByProject: async (projectId) => {
        const pagesbyproject = await http.instance.get("/pages/getpagesbyproject/" + projectId);
        return pagesbyproject.data;
    },
    getResourcesByPageService: async (pageId) => {
        const resourcesbypage = await http.instance.get("/pages/pageresources/" + pageId);
        return resourcesbypage.data;
    },
    addPageService: async (form) => {
        const addpage = await http.instance.post("/pages/addpage", form);
        return addpage.data;
    },
    deletePageService: async (payload) => {
        const deletepage = await http.instance.post("/pages/deletepage/" + payload);
        return deletepage.data;
    },
    addResourceService: async (form) => {
        const addres = await http.instance.post("/pages/addresource", form);
        return addres.data;
    },
    deleteResourceService: async (payload) => {
        const deleteres = await http.instance.post("/pages/deleteresource/" + payload);
        return deleteres.data;
    },

};
export default PagesService;
